import { useContext } from 'react';

import Cabecalho from '../../components/Cabecalho/cabecalho';
import Titulo from '../../components/Titulo/titulo';
import Rodape from '../../components/Rodape/rodape';
import Menu from '../../components/Menu/menu';

import Globais from '../../components/Globais/Globais';
import { AuthContext } from '../../contexts/auth';

export default function Principal(){
  const { ligaMenu } = useContext(AuthContext);

  return (
    <div className='container md:w-11/12 w-full mx-auto md:mt-4 bg-white'>
        <Cabecalho />
        
        <main>
          <Titulo 
            tela={'GQFF - Gerenciamento da Qualidade Funcional do Fluido'} 
            destination=''
          />

        <section
          className="md:grid grid-cols-1"
          style={{
            gridTemplateColumns: ligaMenu
              ? 'minmax(175px, 20%) minmax(60%, 80%)'
              : 'minmax(48px, 5%) minmax(70%, 95%)',
          }}
        >
            <Menu />
            <div>  
            </div>
          </section>
        </main>

        <Rodape versao={Globais.versao}/>
      </div>
    );
  }
  